import React, { useState } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';

const Maps = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    Swal.fire({
      title: '✦ Sending Message... ✦',
      text: 'Please wait while we save your message.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      background: '#ffffff',
      color: '#333',
      didOpen: () => {
        Swal.showLoading();
      }
    });
    
    try {
      // Try multiple possible URLs
      const possibleUrls = [
        'https://theagencybazaar.com/api/contact-messages',
        '/api/contact-messages',
        'http://127.0.0.1:5000/api/contact-messages'
      ];
      
      let response = null;
      let lastError = null;
      
      for (const url of possibleUrls) {
        try {
          response = await axios.post(url, {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            message: formData.message
          }, {
            headers: { 'Content-Type': 'application/json' },
            timeout: 10000
          });
          if (response.data.success) break;
        } catch (err) {
          lastError = err;
          continue;
        }
      }
      
      Swal.close();
      
      if (response && response.data.success) {
        setFormData({ name: '', email: '', phone: '', message: '' });
        
        Swal.fire({
          title: '✦ Message Sent Successfully! ✦',
          text: 'Thank you for reaching out to us. We\'ll get back to you within 24 hours.',
          icon: 'success',
          confirmButtonText: 'Close',
          confirmButtonColor: '#ff2222',
          background: '#ffffff',
          color: '#333',
          iconColor: '#28a745',
          showConfirmButton: true,
          showCloseButton: true,
          closeButtonHtml: '✕',
          focusConfirm: false
        });
      } else {
        throw new Error(lastError?.message || 'Failed to send message');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      Swal.close();
      
      let errorMessage = 'Please check if the backend server is running on port 5000';
      
      if (error.code === 'ECONNABORTED') {
        errorMessage = 'Request timeout. Please try again.';
      } else if (error.response) {
        errorMessage = error.response.data?.message || 'Server error. Please try again later.';
      } else if (error.request) {
        errorMessage = 'Cannot connect to server. Please make sure:\n\n1. Backend server is running (node server.js)\n2. Server is running on port 5000\n3. SQL Server is connected';
      }
      
      Swal.fire({
        title: '✦ Connection Error ✦',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff2222',
        background: '#ffffff',
        color: '#333',
        iconColor: '#ff4444',
        showConfirmButton: true,
        showCloseButton: true,
        closeButtonHtml: '✕'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <style>
        {`
          .split-container {
            display: flex;
            width: 100%;
            min-height: 600px;
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%);
            position: relative;
            overflow: hidden;
          }

          .split-container::before {
            content: '';
            position: absolute;
            width: 200%;
            height: 200%;
            background: radial-gradient(circle, rgba(255,34,34,0.03) 1px, transparent 1px);
            background-size: 50px 50px;
            animation: float 20s linear infinite;
            pointer-events: none;
          }

          @keyframes float {
            0% {
              transform: translate(0, 0);
            }
            100% {
              transform: translate(-50px, -50px);
            }
          }

          .split-container::after {
            content: '';
            position: absolute;
            top: 20%;
            right: -10%;
            width: 500px;
            height: 500px;
            background: radial-gradient(circle, rgba(255,34,34,0.1), transparent 70%);
            border-radius: 50%;
            filter: blur(60px);
            animation: pulse 4s ease-in-out infinite;
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 0.5;
              transform: scale(1);
            }
            50% {
              opacity: 0.8;
              transform: scale(1.1);
            }
          }

          .map-section {
            flex: 1;
            position: relative;
            overflow: hidden;
            border-radius: 0;
          }

          .map-section::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, rgba(255,34,34,0.05), rgba(0,0,0,0.05));
            z-index: 1;
            pointer-events: none;
          }

          .map-section iframe {
            width: 100%;
            height: 100%;
            filter: grayscale(20%) contrast(110%) brightness(1.05);
            transition: all 0.5s ease;
            border: 0;
          }

          .map-section:hover iframe {
            filter: grayscale(0%) contrast(115%) brightness(1.1);
            transform: scale(1.02);
          }

          .form-section {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 50px;
            position: relative;
            backdrop-filter: blur(10px);
            background: rgba(255, 255, 255, 0.7);
            border-left: 1px solid rgba(255, 34, 34, 0.1);
          }

          .form-container {
            max-width: 480px;
            width: 100%;
            animation: glamourFadeIn 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          }

          @keyframes glamourFadeIn {
            from {
              opacity: 0;
              transform: scale(0.9) translateY(30px);
            }
            to {
              opacity: 1;
              transform: scale(1) translateY(0);
            }
          }

          .form-header {
            text-align: center;
            margin-bottom: 40px;
          }

          .glamour-badge {
            display: inline-block;
            background: linear-gradient(135deg, #ff2222, #ff6b6b);
            padding: 5px 15px;
            border-radius: 50px;
            font-size: 12px;
            font-weight: 600;
            color: white;
            margin-bottom: 15px;
            letter-spacing: 1px;
            box-shadow: 0 5px 15px rgba(255,34,34,0.3);
          }

          .form-header h3 {
            font-size: 42px;
            font-weight: 800;
            background: linear-gradient(135deg, #333, #ff2222);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            margin-bottom: 12px;
            letter-spacing: -0.5px;
          }

          .form-header p {
            color: #666;
            font-size: 15px;
          }

          .form-group {
            margin-bottom: 25px;
            position: relative;
          }

          .form-group input,
          .form-group textarea {
            width: 100%;
            padding: 16px 20px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 16px;
            font-size: 14px;
            transition: all 0.4s ease;
            background: rgba(255, 255, 255, 0.9);
            color: #333;
            font-family: inherit;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
          }

          .form-group textarea {
            resize: vertical;
            min-height: 110px;
          }

          .form-group input::placeholder,
          .form-group textarea::placeholder {
            color: #999;
          }

          .form-group input:focus,
          .form-group textarea:focus {
            outline: none;
            border-color: #ff2222;
            background: #ffffff;
            box-shadow: 0 0 0 4px rgba(255, 34, 34, 0.1);
            transform: translateY(-2px);
          }

          .submit-btn {
            width: 100%;
            padding: 16px;
            background: linear-gradient(135deg, #ff2222, #cc0000, #ff2222);
            background-size: 200% 200%;
            color: white;
            border: none;
            border-radius: 16px;
            font-size: 16px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.4s ease;
            position: relative;
            overflow: hidden;
            text-transform: uppercase;
            letter-spacing: 1px;
            animation: gradientShift 3s ease infinite;
          }

          @keyframes gradientShift {
            0%, 100% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
          }

          .submit-btn::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
            transition: left 0.5s ease;
          }

          .submit-btn:hover::before {
            left: 100%;
          }

          .submit-btn:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 30px rgba(255, 34, 34, 0.4);
            letter-spacing: 2px;
          }

          .submit-btn:active {
            transform: translateY(0);
          }

          .submit-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none;
          }

          .form-decoration {
            position: absolute;
            bottom: 30px;
            right: 30px;
            width: 100px;
            height: 100px;
            background: radial-gradient(circle, rgba(255,34,34,0.1), transparent);
            border-radius: 50%;
            filter: blur(30px);
            pointer-events: none;
          }

          @media (max-width: 968px) {
            .split-container {
              flex-direction: column;
              min-height: auto;
            }

            .map-section {
              height: 450px;
            }

            .form-section {
              padding: 40px 25px;
            }

            .form-container {
              max-width: 100%;
            }

            .form-header h3 {
              font-size: 32px;
            }
          }

          @media (max-width: 768px) {
            .form-header h3 {
              font-size: 28px;
            }

            .glamour-badge {
              font-size: 10px;
            }
          }

          @media (max-width: 480px) {
            .map-section {
              height: 350px;
            }

            .form-header h3 {
              font-size: 24px;
            }

            .form-group input,
            .form-group textarea {
              padding: 12px 16px;
            }

            .submit-btn {
              padding: 14px;
              font-size: 14px;
            }
          }
        `}
      </style>

      <div className="split-container">
        <div className="map-section">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.6642649345226!2d81.01171959999999!3d26.8506288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bff1edebf868d%3A0xb927c74bb0ef81f1!2sAgency%20Bazaar!5e0!3m2!1sen!2sin!4v1777265730075!5m2!1sen!2sin" 
            width="100%" 
            height="100%" 
            title="Google Maps - Agency Bazaar"
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="form-section">
          <div className="form-container">
            <div className="form-header">
              <div className="glamour-badge">✦ LET'S CONNECT ✦</div>
              <h3>Send a Message</h3>
              <p>We'll respond within 24 hours</p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? '✦ SENDING... ✦' : '✦ SEND MESSAGE ✦'}
              </button>
            </form>
          </div>
          <div className="form-decoration"></div>
        </div>
      </div>
    </>
  );
};

export default Maps;


